<app-header-nav [hideProgress]="true">
  <div class="row justify-content-center">
    <div class="col col-md-6 col-lg-6">
      <div class="p-4">
        @if (token && !invalid()) {
          @if (submitted()) {
            @if (declined()) {
              <h1>Declined</h1>
              <p>You have declined the authorisation.</p>
            } @else {
              <h1 class="success">Success</h1>
              <p>Thank you for taking the time to complete the required authorisation.</p>
            }
            <div class="row g-3 row-cols-1 row-cols-md-2 pt-3">
              <div class="col-12 col-md-auto ms-auto">
                <button
                  class="btn btn-primary d-block w-100"
                  id="closePage"
                  (click)="onClose()">
                  Close
                </button>
              </div>
            </div>
          } @else {
            <h1>Directors Authorisation</h1>
            @if (label) {
              <app-pays-checkbox
                [(control)]="chkBoxValue"
                [label]="label"
                id="authCheckbox"></app-pays-checkbox>
              <div class="row g-3 row-cols-1 row-cols-md-2 pt-3">
                <div class="col-12 col-md-auto">
                  <button
                    class="btn btn-primary d-block w-100"
                    id="submitApproval"
                    [disabled]="!chkBoxValue"
                    (click)="onSubmit()">
                    Authorise
                  </button>
                </div>
                <div class="col col-md-auto">
                  <button
                    class="btn d-block btn-outline-dark w-100"
                    id="declineApproval"
                    [disabled]="!chkBoxValue"
                    (click)="onDecline()">
                    Decline
                  </button>
                </div>
              </div>
            } @else {
              <app-loader></app-loader>
            }
          }
        } @else {
          <h1>Oh no...</h1>
          @if (tokenError && !alreadyResponded) {
            {{ tokenError }}
          }
          @if (alreadyResponded) {
            This request has already been responded to or processed.
          }
        }
      </div>
    </div>
  </div>

  <app-help-btn></app-help-btn>
</app-header-nav>
